"use client"

import { graphql } from "@/gql"
import { useQuery } from "@apollo/client"
import { Sidebar } from "../Sidebar"
import { MobileNav } from "./MobileNav"
import { ChatCountUpdater } from "./ChatCountUpdater"
import { NovaSession } from "@/types"
import { useMessagingToken } from "@/hooks/useMessagingToken"

interface Props {
  noNav?: boolean
  serverSession: NovaSession
}

const SidebarClientQuery = graphql(`
  query SidebarClientQuery {
    currentUser {
      id
      uuid
      ...Sidebar
      ...MobileNav
    }
  }
`)

export const NavQueryWrapper: React.FC<Props> = ({ noNav, serverSession }) => {
  const { data } = useQuery(SidebarClientQuery, {
    fetchPolicy: "cache-and-network",
  })
  const messagingToken = useMessagingToken()
  const uuid = data?.currentUser?.uuid

  return (
    <>
      {uuid && messagingToken && <ChatCountUpdater uuid={uuid} messagingToken={messagingToken} />}

      <div className={noNav ? "hidden" : ""}>
        <MobileNav serverSession={serverSession} user={data?.currentUser} />
      </div>

      <Sidebar serverSession={serverSession} user={data?.currentUser} />
    </>
  )
}
